import { render, staticRenderFns } from "./EzDialog.vue?vue&type=template&id=05c98a07&"
import script from "./EzDialog.vue?vue&type=script&lang=js&"
export * from "./EzDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports